import React from 'react'
import { useTranslations } from '~/components/Locale'

export const NotFound: React.FC = () => {
	const t = useTranslations('templates.404')
	return (
		<div className="py-20 text-center md:py-40">
			<h1 className="section-header__title h2">{t?.title}</h1>
			<p>{t?.subtext}</p>
			<p className="flex flex-wrap justify-center gap-4">
				<a href="https://support.auk.com" className="btn btn--primary">
					{t?.contact_support}
				</a>
				<a href="/" className="btn btn--primary">
					{t?.go_back}
				</a>
			</p>
			<style>{'.main-content__wrapper { visibility: visible !important; }'}</style>
		</div>
	)
}
